import { render, staticRenderFns } from "./LoyaltyStoreLocked.vue?vue&type=template&id=29ff28ec&"
import script from "./LoyaltyStoreLocked.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStoreLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports